import React from "react";

const DataInput = ({
  age,
  setAge,
  gender,
  setGender,
  uploadProgress,
  handleUpload,
  handleSendData,
}) => {
  return (
    <div className="mt-32 flex flex-col items-center justify-center">
      <div className="flex flex-col ">
        <label className="font-semibold mb-2" htmlFor="age">
          Age
        </label>
        <input
          className="border-2 h-[50px] border-xgreen rounded-3xl p-1 pl-4 outline-none"
          type="number"
          name="age"
          placeholder="Enter your age"
          value={age}
          onChange={(e) => setAge(e.target.value)}
        />
      </div>
      <div className="flex flex-col mt-4">
        <h2 className="font-semibold mb-2 w-full">Sex</h2>
        <div className="flex mx-10">
          <div className="px-2 pr-6">
            <input
              type="radio"
              className="w-4 h-4 mr-1 checked:bg-xgreen bg-green-100 border-gray-300 text-xgreen focus:outline-none focus:ring-0"
              id="male"
              name="gender"
              value="male"
              checked={gender === "male"}
              onChange={() => setGender("male")}
            />
            <label htmlFor="male">Male</label>
          </div>
          <div className="px-2 pl-6">
            <input
              type="radio"
              className="w-4 h-4 mr-1 checked:bg-xgreen bg-green-100 border-gray-300 text-xgreen focus:outline-none focus:ring-0"
              id="female"
              name="gender"
              value="female"
              checked={gender === "female"}
              onChange={() => setGender("female")}
            />
            <label htmlFor="female">Female</label>
          </div>
        </div>
      </div>

      <div className="my-1 mt-8">
        {uploadProgress > 0 && (
         <>
         <progress
            className="w-[280px] rounded-lg  border"
            value={uploadProgress}
            max="100"
          ></progress>
          {uploadProgress==100 && <h4 className="text-center text-sm font-semibold mb-2">Upload Complete</h4>}
         </>
        )}
      </div>
      <label
        htmlFor="dropzone-file"
        className="text-xgreen w-[300px] h-[50px] rounded-3xl bg-white flex justify-center items-center text-md border-2 border-xgreen font-bold"
      >
        <input
          id="dropzone-file"
          className="bg-blue-400 hidden"
          type="file"
          accept="image/*"
          onChange={(e) => handleUpload(e)}
        />
        {/* {uploadProgress === 100 ? "Upload Complete" : "Upload"} */}
        Upload
      </label>

      <button className="bg-xgreen w-[300px] h-[50px] mt-4 rounded-3xl text-white font-bold" onClick={handleSendData}>Process</button>
    </div>
  );
};

export default DataInput;
